import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEmail1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconEmail1"><Path d="M2.57918 4L12 11.7079L21.4208 4H2.57918Z" fill="currentColor"/><Path d="M2 6.11025V20H22V6.11024L12 14.2921L2 6.11025Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEmail1;
